  class QuickBuy extends HTMLElement {
    constructor() {
      super();
      this.status = { loading: false };
    }

    connectedCallback() {
      this.openBtn = this.querySelector('.add-to-bag-panel__panel-button');
      this.panel = this.querySelector('.add-to-bag-panel');
      this.closeBtn = this.querySelector('.add-to-bag-panel__close-button');
      this.form = this.querySelector('form');
      this.submitBtn = this.querySelector('.ajax-submit');

      this.initEvents();
    }

    initEvents() {
      if (this.openBtn && this.panel) {
        this.openBtn.addEventListener('click', (e) => this.openPanel(e));
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.closePanel());
      }

      if (this.submitBtn) {
        this.submitBtn.addEventListener('click', () => this.submitForm());
      }
    }

    openPanel(e) {
      e.preventDefault();
      const id = this.openBtn.dataset.quickbuy;
      const panel = this.querySelector(`.add-to-bag-panel`);
      if (panel) {
        panel.setAttribute('active', 'true');
        this.panel.classList.remove('hide');

      }
    }

    closePanel() {
      if (this.panel) 
        {
            this.panel.setAttribute('active', 'false');
            this.panel.classList.add('hide');
        }
    }

    submitForm() {
      if (this.status.loading) return;

        // Find the <select name="id"> element
        const variantSelect = this.querySelector('select[name="id"]');
        if (!variantSelect) {
          this.handleError('No variant selector found');
          return;
        }

        const variantId = variantSelect.value; // Get selected variant ID

        console.log('Selected Variant ID:', variantId);

        this.status.loading = true;
        this.submitBtn.classList.add('btn--loading');


      // Build request body manually
      const bodyData = new FormData();
      bodyData.append('id', variantId);
      bodyData.append('quantity', 1);

      fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        body: bodyData ,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
      })
        .then((res) => res.json())
        .then((data) => {
          this.submitBtn.classList.remove('btn--loading');
          this.status.loading = false;

          if (data.status === 422) {
            this.handleError(data.description || 'Product could not be added');
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          } else {
            this.handleSuccess(data);
          }
        })
        .catch((err) => {
          this.submitBtn.classList.remove('btn--loading');
          this.status.loading = false;
          this.handleError(err.message || 'Network error');
        });
    }

    handleError(message) {
      console.log(`Error: ${message}`);
    }

    handleSuccess(product) {
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: product }));
      this.closePanel();
    }
  }

  customElements.define('quick-buy', QuickBuy);
